import GallerySwiper from "../Product/GallerySwiper";
import "./Product.scss";
import "../BlogPages/MainBlog.scss";
import "../OrdibeheshtMainPage/OrdibeheshtMainPage.scss";
import AddToShoppingBag from "./AddToShoppingBag";
import TabComponent from "./Tab";
import {useEffect, useState} from "react";
import Title from "../Title/Title";
import ProductCardContainer from "../ProductCard/ProductCardContainer";
import axios from "axios";
import CardBlog from "../BlogPages/CardBlog";
import {prefixUrl} from "../../Utils/utilsData";
import TwoBanners from "../TwoBanners/TwoBanners";
import "../BlogPages/MainBlog.scss";
import {useParams, Link} from "react-router-dom";
import Loader from "../Loader/Loader";
import {toast} from "react-toastify";
import CustomMetaTags from "../SeoManage/CustomMetaTags ";

function Product() {
  const [productData, setProductData] = useState([]);
  const [reload, setReload] = useState("");
  const {id} = useParams();
  const [isLoad, setIsLoad] = useState(false)

  const [setValue] = CustomMetaTags({})

  useEffect(() => {
    const productId = id.match(/\d+/)[0];

    axios.post(`${prefixUrl()}/product/detail.php?productId=${productId}`)
      .then((response) => {
        if (response.data.status) {
          setProductData(response.data.output);
          setIsLoad(true)
          if (!Array.isArray(response.data.output.product?.seo)) {
            setValue(response.data.output.product?.seo)
          }
          } else {
            toast.error("خطا در بر قراری ارتباط")
          }
      });
  }, [id, reload]);

  return (
    <>
      {isLoad ?
        <div className="ordibeheshtMainPagePrntContainer__ product-page">
          <div className="Product">
            <div className="slider-side responsive_mrg">
          <span className="breadcrumb">
            <Link to={"/group"}> دسته بندی</Link>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
            >
              <path
                d="M9.37383 12.9188C9.25508 12.9188 9.13633 12.8751 9.04258 12.7813L4.96758 8.70631C4.30508 8.04381 4.30508 6.95631 4.96758 6.29381L9.04258 2.21882C9.22383 2.03757 9.52383 2.03757 9.70508 2.21882C9.88633 2.40007 9.88633 2.70007 9.70508 2.88132L5.63008 6.95631C5.33008 7.25631 5.33008 7.74381 5.63008 8.04381L9.70508 12.1188C9.88633 12.3001 9.88633 12.6001 9.70508 12.7813C9.61133 12.8688 9.49258 12.9188 9.37383 12.9188Z"
                fill="#B9B9B9"
              />
            </svg>
            <Link
              to={`/Group/SubGroups/${productData?.product?.groupId}`}
              state={{name: productData?.product?.groupName}}
            >
              {productData?.product?.groupName}
            </Link>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
            >
              <path
                d="M9.37383 12.9188C9.25508 12.9188 9.13633 12.8751 9.04258 12.7813L4.96758 8.70631C4.30508 8.04381 4.30508 6.95631 4.96758 6.29381L9.04258 2.21882C9.22383 2.03757 9.52383 2.03757 9.70508 2.21882C9.88633 2.40007 9.88633 2.70007 9.70508 2.88132L5.63008 6.95631C5.33008 7.25631 5.33008 7.74381 5.63008 8.04381L9.70508 12.1188C9.88633 12.3001 9.88633 12.6001 9.70508 12.7813C9.61133 12.8688 9.49258 12.9188 9.37383 12.9188Z"
                fill="#B9B9B9"
              />
            </svg>
            {productData?.product?.title}
          </span>
              <GallerySwiper GalleryPic={productData?.product?.images}/>
            </div>
            <AddToShoppingBag productInfo={productData?.product}/>
          </div>
          <TabComponent
            info={productData?.product}
            reload={reload}
            setReload={setReload}
          />
          <div className="ordibeheshtMainPageContainer__ productPage__ responsive_mrg">
            <Title
              englishTitle={"Latest Products"}
              title={"جدیدترین محصولات"}
              showAll={false}
            />
            <ProductCardContainer
              data={productData?.lastProducts}
              type={"half"}
              className={"productPage__"}
            />
            <TwoBanners data={productData?.twoBannersData}/>

            <Title
              englishTitle={"similar products"}
              title={"در این سبد خرید می یابید"}
              showAll={false}
            />

            {/* <ProductCardContainer data={data.slice(0, 4)} type={"full"} /> */}

            <Title
              englishTitle={"similar Contents"}
              title={"مطالب مشابه"}
              showAll={false}
            />
            <div
              className="main-blog-page productBlogPage__"
              style={{marginBottom: 80}}
            >
              <div className="row-middle">
                {productData?.blogs?.slice(0, 3).map((item) => (
                  <CardBlog key={item.id} blogData={item}/>
                ))}
              </div>
            </div>
          </div>
        </div>
        : <Loader/>}
    </>
  );
}

export default Product;
